// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2vimm","label":"Radio_label__45awz","checkMark":"Radio_checkMark__DtR5p","disabled":"Radio_disabled__3UJA4"};